var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "transparent",
    className: "box",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 15,
    height: 15,
    rx: 1,
    stroke: "#DCDCDC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0031 0.411099C18.4085 -0.0798416 19.1237 -0.13954 19.6006 0.27776C20.0776 0.69506 20.1356 1.43133 19.7302 1.92227L10.0969 13.5889C9.68512 14.0876 8.95555 14.1401 8.48039 13.7053L3.3804 9.03864C2.91258 8.61057 2.87044 7.87316 3.28628 7.39158C3.70212 6.91 4.41847 6.86662 4.88629 7.29469L9.12024 11.1689L18.0031 0.411099Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.b0966fc6b6743dbc78a1aec8163dbae3.svg";
export { ForwardRef as ReactComponent };